import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Keyword from './Keyword'

const List = ({ children, items = [], activeKeywords = [], ...props }) => {
  const highlightKeywords = (text) => {
    const keywordPattern = /\[\[(.*?)\]\]/;
    const values = [];
    let match = keywordPattern.exec(text), parts;

    if (!match) {
      return text;
    }

    for (let i = 0; match != null; match = keywordPattern.exec(text), i++) {
      parts = text.split(match[0]);
      values.push(<span key={i}>{parts[0]}</span>);
      values.push(<Keyword key={++i} activeKeywords={activeKeywords} keyword={match[1]} />);
      text = parts[1];
    }

    return values;
  };

  return (
    <ul className="dots">
      {items.map((row, i) => <li key={i} className={cn(`text-${row.style}`)}>{highlightKeywords(row.body)}</li>)}
    </ul>
  );
};

List.propTypes = {
  items: PropTypes.array.isRequired,
  activeKeywords: PropTypes.array
};

export default List;



// WEBPACK FOOTER //
// ./src/components/resume/List.js